import { useContext } from "react";
import { ReactComponent as SearchIcon } from "assets/images/icons/Search.svg";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import testIds from "constants/testIds";
import { ILastVisits } from "types/Recent";
import AutoSuggestSearch from "components/organisms/Search/AutoSuggestSearch";
import { handleSuggestionExpand } from "store/store";
import NavContext from "./NavContext";

interface SearchProps {
  getSuggestionResult: (suggestion: ILastVisits[]) => void;
  setIsExpanded: Function;
  selectedSearch: string;
  setShowRecent: (showRecent: boolean) => void;
  setSelectedSearch: (selectedSearch: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  setStatus: (status: boolean) => void;
}

function Search({
  getSuggestionResult,
  setIsExpanded,
  selectedSearch,
  setSelectedSearch,
  setShowRecent,
  setIsLoading,
  setStatus,
}: SearchProps) {
  const { navigationConfig, setNavigationConfig } = useContext(NavContext);
  const { actions } = useStateMachine({ handleSuggestionExpand });

  const expandNavigation = () => {
    setNavigationConfig({ ...navigationConfig, expanded: true });
    navigationConfig.handleNavigation(navigationConfig.expanded);
    setIsExpanded(true);
  };

  const closeNavigation = () => {
    setNavigationConfig({ ...navigationConfig, expanded: false, isShown: !navigationConfig.isMobile });
    navigationConfig.handleNavigation(navigationConfig.expanded);
  };

  const handleRecentView = () => {
    actions.handleSuggestionExpand({
      manageSuggestion: true,
    });
  };

  if (!navigationConfig.expanded) {
    return (
      <div
        className="universal-search--container"
        onClick={expandNavigation}
        onKeyDown={expandNavigation}
        role="button"
        tabIndex={0}
        data-testid={testIds.MENU_EXPAND_BUTTON}
      >
        <div role="presentation" onClick={handleRecentView} className="navigation-search--icon">
          <SearchIcon />
        </div>
      </div>
    );
  }
  if (navigationConfig.expanded) {
    return (
      <div className="universal-search--container">
        <AutoSuggestSearch
          closeNavigation={closeNavigation}
          getSuggestionResult={getSuggestionResult}
          setShowRecent={setShowRecent}
          selectedSearch={selectedSearch}
          setSelectedSearch={setSelectedSearch}
          setIsLoading={setIsLoading}
          setStatus={setStatus}
        />
      </div>
    );
  }
  return null;
}

Search.propTypes = {
  getSuggestionResult: PropTypes.func.isRequired,
  setSelectedSearch: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default Search;
